import { Component, ViewChild } from '@angular/core';
import { CustomersTableComponent } from '../customers-table/customers-table.component';
import { SharedFiltersComponent } from '../../../shared/components';
import { ContractFilter } from '../../../interfaces/contract-filter.interface';

@Component({
  selector: 'app-customers-wrapper',
  imports: [
    CustomersTableComponent,
    SharedFiltersComponent
  ],
  templateUrl: './customers-wrapper.component.html',
  styleUrl: './customers-wrapper.component.scss'
})
export class CustomersWrapperComponent {
  @ViewChild(CustomersTableComponent) customersTable!: CustomersTableComponent;

  // Initial filter for shared-filters component
  initialFilter: ContractFilter = {
    searchTerm: '',
    statusFilter: [],
    biztositoFilter: [],
    assigneeFilter: [],
    dateFromFilter: null,
    dateToFilter: null,
    productFilter: [],
    paymentFrequencyFilter: [],
    currencyFilter: [],
    policyNumberFilter: ''
  };

  onFilterChange(filter: ContractFilter): void {
    console.log('Filter changed:', filter);
    // Pass the search term to the customers table
    if (this.customersTable) {
      this.customersTable.filterData(filter.searchTerm);
    }
  }

  onClearFilters(): void {
    console.log('Filters cleared');
    // Clear the filter in the customers table
    if (this.customersTable) {
      this.customersTable.filterData('');
    }
  }
}